module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "form js-form"
  }, [_c('submenu'), _vm._v(" "), _c('list', {
    staticClass: "view__content",
    attrs: {
      "data": _vm.entries(),
      "fields": _vm.headers(),
      "pagination": _vm.pagination,
      "hideCreate": false
    },
    on: {
      "paginate": _vm.paginate,
      "action": _vm.action
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dbbfd45a!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/account/Users.vue
// module id = 763
// module chunks = 1